<div class="wrapper">
  <div class="toolbar px-0">
    <h3 class="ml-0 pointer breadcrumb-back" [routerLink]="['/gamification/tips']" [queryParams]="{domain: domain}"><i
        class="fas fa-chevron-left"></i></h3>
    <h3 class="text-left">Coping tips for {{subparam_label|t}}</h3>
    <button class="btn btn-sm btn-warning btn-add text-white mr-0 px-2" (click)="add()">
      <i class="fa fa-plus"></i>
    </button>
  </div>
  <div class="tablescroll">
    <table style="">
      <thead>
        <tr>
          <th></th>
          <th>Tips</th>
          <th>Image</th>
          <th>Video</th>
          <th></th>
        </tr>
      </thead>
      <tbody style="">
        <tr *ngFor="let item of tips; let ind=index" style="border-radius: 4px;">
          <td style="border-right: 1px solid white; text-align: center; width: 55px">{{ind + 1}}</td>
          <td>{{item.title}}</td>
          <td>
            <img *ngIf="item.images.length" style="width: auto;height: 66px;margin-left: 30px;margin-right: 30px;"
              [src]="[item.tip_id, item.images[0].image_id]|authImage:'tip'|async">
          </td>
          <td>
            <!-- <img *ngIf="item.videos.length" style="width: auto;height: 66px;margin-left: 30px;margin-right: 30px;"
          [src]="[item.pros_and_cons_id, item.videos[0].video_id]|authImage:'pros_and_cons'|async"> -->
            <img *ngIf="item.videos.length" style="width: auto;height: 66px;margin-left: 30px;margin-right: 30px;"
              src="/assets/images/thumbnail.jpg">
          </td>
          <td>
            <img class="m-2 pointer mr-4" src="assets/images/ic_edit.svg" (click)="edit(item)">
            <img class="m-2 pointer mr-4" src="assets/images/ic_delete.svg" (click)="delete(item)">
          </td>
        </tr>
        <tr *ngIf="dataSub && !dataSub.closed">
          <td colspan="5">
            <div class="blink text-center py-4">Loading...</div>
          </td>
        </tr>
        <tr *ngIf="!(dataSub && !dataSub.closed) && !tips.length">
          <td colspan="5">
            <div class="text-center py-4">No Tips to display</div>
          </td>
        </tr>
        <!-- <tr><td colspan="5" class="bg-white"><br></td></tr> -->
      </tbody>
    </table>
  </div>
</div>